// ----------------------------------------------------------------------

export default {
  MuiCardHeader: {
    titleTypographyProps: { variant: 'h6' },
    subheaderTypographyProps: { variant: 'body2' },
  },
};
